import http from '../utils/http';
import i18n from '@/main';

const baseUrl = '/territorios-vega';

export default {
    validarSobreposicaoTerritorioVega(geometria) {
        return http.post({
            url: baseUrl + '/validar-sobreposicao-territorio-vega',
            data: { geoJson: geometria },
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.validandoSobreposicaoDeTerritoriosVegaCadastrados'
            )
        });
    },
    findByCodigo(codigo) {
        return http.get({
            url: baseUrl + `/${codigo}`,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.procurandoTerritorioVega'
            )
        });
    }
};
